import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useFacebookLeadsSync() {
  return useMutation({
    mutationFn: async ({ startDate, endDate }: { startDate?: string; endDate?: string }) => {
      const { data, error } = await supabase.functions.invoke('facebook-leads-import', {
        body: {
          start_date: startDate,
          end_date: endDate
        }
      });

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      toast.success(`Leads importados com sucesso!`, {
        description: `${data.imported} leads de ${data.date_range.start} até ${data.date_range.end}`
      });
    },
    onError: (error) => {
      console.error('Error syncing leads:', error);
      toast.error('Erro ao sincronizar leads', {
        description: String(error)
      });
    }
  });
}
